import { defineComponent as _defineComponent } from 'vue'
import {ref} from "vue";
import {useCacheStore, useSolanaStore, useWalletStore} from "@/pinia";
import MultiWallet from "@/components/wallet/MultiWallet.vue";
import {useAlertStore} from "@/pinia/alertStore";
import store from "@/store";
import {parseCustomError} from "@/api/token_swap/errors";

//data

export default /*#__PURE__*/_defineComponent({
  __name: 'FundDeposit',
  setup(__props) {

const open = ref<boolean>(false)
const copyLoading = ref<boolean>(false)
const transferAmount = ref<number>(0)

const tempWallet = ref<any>()

// store
const cacheStore = useCacheStore();
const walletStore = useWalletStore();
const alertStore = useAlertStore();
const solanaStore = useSolanaStore();

function setTokenAmount(amount) {
	transferAmount.value = amount
}

function copy() {
	copyLoading.value = true;
	navigator.clipboard.writeText(walletStore.address.toString());
	alertStore.success("Address Copied");
	setTimeout(() => {
		copyLoading.value = false;
	}, 1000);
}

function walletAdapter(e) {
	console.log("FundDeposit::walletAdapter", e)
	tempWallet.value = e
}

async function deposit() {
	if (tempWallet.value) {
		alertStore.error("No wallet detected")
		return
	}


	const srcWallet = tempWallet.value.publicKey
	const dstWallet = walletStore.address
	const absAmountIn = transferAmount.value * Math.pow(10, 9)

	const txn = await solanaStore.tokenClient
		.getSendTransferSolTransaction(srcWallet, dstWallet, absAmountIn, true)
		.catch((e) => {
			alertStore.error(e, "Transfer failed");
		});

	const signedTxn = await tempWallet.value.signTransaction(txn)
		.catch((e) => {
			console.error("Sign fail", e)
			alertStore.error(e, "Failed to sign transaction");
		});

	//@ts-ignore
	const sig = await solanaStore.client?.sendRawTransaction(signedTxn.serialize(), {signers: [tempWallet.publicKey], skipPreflight: true}).catch(e => {
		console.error("fundDeposit transaction failed", e)
		//@ts-ignore
		alertStore.error(parseCustomError(e.message || e), `Transaction Failed`)
		//@ts-ignore
		window.gtag("event", `deposit_fail`, {error: e})
	})

	if (sig)
		store.commit("signatures/add_signature", {sig: sig, status: {}})
}


return { __sfc: true,open, copyLoading, transferAmount, tempWallet, cacheStore, walletStore, alertStore, solanaStore, setTokenAmount, copy, walletAdapter, deposit, MultiWallet }
}

})